'use strict';

var formatErrorMessage = require('./format-error-message.cjs');

const warned = new Set();
function warnOnce(condition, message, errorCode) {
    if (condition || warned.has(message))
        return;
    console.warn(formatErrorMessage.formatErrorMessage(message, errorCode));
    warned.add(message);
}

exports.warnOnce = warnOnce;
//# sourceMappingURL=warn-once.cjs.map
